











import { defineComponent } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';
import { ParagraphSize } from '@getaccept/lib-ui';
import CheckboxIcon from '../assets/checkbox.svg';

export default defineComponent({
  components: { CheckboxIcon },
  props: {
    checkList: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup() {
    return {
      ParagraphSize,
    };
  },
});
